import React from 'react';

export function FinalCTA() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section
      className="px-6 py-24 text-center"
      style={{ borderTop: '0.5px solid rgba(255,255,255,0.06)' }}
    >
      <div className="max-w-2xl mx-auto">
        <h2
          className="font-semibold"
          style={{
            color: '#f4f1ea',
            fontSize: 'clamp(24px, 3.5vw, 32px)',
            letterSpacing: '-0.02em',
            lineHeight: 1.2,
          }}
        >
          Ready to plan smarter?
        </h2>
        <p
          className="mt-3 text-[15px]"
          style={{ color: 'rgba(244,241,234,0.6)' }}
        >
          Join investors using MyCryptoPlanner to make every move intentional.
        </p>
        <div className="mt-8">
          <a
            href="#pricing"
            onClick={scrollToPricing}
            className="inline-block text-[14px] font-medium px-5 py-3 rounded-lg transition-transform hover:scale-[1.02]"
            style={{ backgroundColor: '#f4f1ea', color: '#0c0e12' }}
          >
            Get started
          </a>
        </div>
      </div>
    </section>
  );
}
